/* Copyright (c) 2025 Xperi. All Rights Reserved. */

const FilteredGuideInvisibleRow = (): JSX.Element => {
    return (
        <div
            className="filter-guide-table-invisible-container"
            data-testid="filtered-guide-table-row"
        >
            <div className="filtered-guide-generic-row"></div>
        </div>
    );
};

export default FilteredGuideInvisibleRow;
